/**
 * useRoleFlags — Sprint 2 frontend refactor (F3+).
 *
 * Mevcut tab/component'ler `userRole` prop alıyor ve içeride `userRole === "X"`
 * gibi 5-50 arası hard-coded kontrol yapıyor. Bu hook:
 *   - useAuthorization()'dan permission + chain bilgisini açar (`has`, `hasAny`, vb.)
 *   - userRole'den intermediate rol flag'leri türeti (isAdmin, isMudur, vb.)
 *
 * Tek satır kullanım — tab içinde:
 *   const { has, isAdmin, isMudur, isParkGorevlisi, ... } = useRoleFlags(userRole);
 *
 * NOT (intermediate aşama):
 *   `isAdmin`, `isMudur` vb. flag'ler nihai hedef DEĞİL — uzun vadede her
 *   kullanım yeri doğru permission slug'a evrilmeli (örn. `isMudur` →
 *   `has('izin.son_onay_mudur')`). Şu an pratik geçiş için intermediate flag'leri
 *   tercih ediyoruz.
 */
import { useMemo } from "react";

import { useAuthorization } from "./AuthorizationContext";


export function useRoleFlags(userRole) {
  const authz = useAuthorization();
  const role = String(userRole || "").trim().toLowerCase();

  const flags = useMemo(
    () => ({
      // userRole === / !== ... pattern'ları için intermediate flag'ler
      isAdmin: role === "admin" || role === "baskan",
      isMudur: role === "mudur",
      isMudurYardimcisi: role === "mudur_yardimcisi",
      isBolgeMuhendisi: role === "bolge_muhendisi",
      isFormen: role === "formen",
      isParkGorevlisi:
        role === "park_gorevlisi" || role === "cim_ekibi" || role === "gorevli",

      // Aşama B (migration 0061): isGolgeAdmin kaldırıldı (golge_admin
      // rolü ve kullanıcıları tamamen silindi). Eski referanslar her zaman
      // false döner — geçici geriye uyum için sabit false bırakıldı.
      isGolgeAdmin: false,

      // Yaygın kompozit flag'ler — semantik anlam taşır
      isManagerView: authz.has("personel.listele"),
      isManagerEdit: authz.has("personel.duzenle"),
    }),
    [role, authz]
  );

  return { ...authz, ...flags };
}


export default useRoleFlags;
